<template>
  <Tile
    v-if="parent"
    :link="getLabLink(lab, parent)"
    :background="`${getBackground(parent)}`"
    :item="lab"
    :isFreeTrialUser="false"
    :isResumeSnipeShown="false"
    :isDifficultyShown="false"
    :isInstructorPictureShown="false"
    :progress="0"
    :displayVendor="false"
    :displayAllInstructors="false"
    :learningAreaColor="getLearningAreaColor(parent)"
    :learningArea="getLearningArea(parent)"
    :displayDuration="false"
    :showAddedDate="true"
    :displayRunningPill="true"
    :running="running"
    :displayLabType="false"
    :displayParentCourse="true"
    :courseName="parent ? parent.name : ''"
    :displayInstructor="false"
    @element-rend="handleRememberPosition"
  ></Tile>
</template>

<script>
import CONSTANTS from '@/constants'
import { defineComponent } from '@vue/composition-api'
import {
  truncateText,
  getEntities,
  getLearningArea,
  getLearningAreaColor,
} from '@/helpers'
import Difficulty from '@/components/properties/Difficulty.vue'
import PreviewProgressBar from '@/components/properties/PreviewProgressBar.vue'
import AddedDate from '@/components/properties/AddedDate.vue'
import LabFilterIcon from '@/assets/icons/search/lab_filter.svg'
import RunningPill from '@/components/properties/RunningPill.vue'
import Tile from '@/components/layout/Tile.vue'

export default defineComponent({
  name: 'LabTile',
  components: {
    Difficulty,
    PreviewProgressBar,
    AddedDate,
    LabFilterIcon,
    RunningPill,
    Tile,
  },
  inject: ['getBreakpoint'],
  computed: {
    isMobile() {
      return this.getBreakpoint() === 'mobile'
    },
  },
  data: () => {
    return {
      getLearningAreaColor,
      getLearningArea,
    }
  },
  props: {
    lab: {
      type: Object,
      required: true,
    },
    height: {
      type: [String, Number],
      required: false,
      default: () => 245,
    },
    width: {
      type: [String, Number],
      required: false,
      default: () => 310,
    },
    running: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    backgroundImg: {
      type: String,
      required: false,
    },
    parent: {
      type: Object,
      required: false,
      default: () => {},
    },
    showLabType: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    displayVendor: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    displayIcon: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  methods: {
    getLabTypeLabel(labType) {
      if (!labType) {
        return null
      }
      const types = {
        azure: 'Azure',
        github: 'GitHub',
        els: 'eLearningSecurity',
        pta: 'Pentester Academy',
      }
      return types[labType]
    },
    truncateTitle(value, length = null) {
      return truncateText(value, !length ? this.maxLength.value : length)
    },
    getLAreaColor(larea) {
      return CONSTANTS.LEARNING_AREAS.COLORS[larea.id]
    },
    getLabLink(lab, parent) {
      if (parent) {
        return this.$buildContentLink('lab', lab, parent)
      }
      return {}
    },
    getVendor(item) {
      return getEntities.getVendorName(item)
    },
    getBackground(parent) {
      if (parent) {
        return this.$getPlaylistBackground(parent.objectID)
      }
      return null
    },
    handleRememberPosition(elId) {
      this.$emit('elmt-rend', elId)
    },
  },
})
</script>
